<template>
  <div>
    <vs-row class="mb-3">
      <vs-button color="dark" disabled type="flat"
        ><h5>Device Management /</h5></vs-button
      >
      <vs-button type="flat" to="/gateway"> <h5>Gateway</h5></vs-button>
      <vs-button color="dark" disabled type="flat"
        ><b><h5>/ View Gateway</h5></b>
      </vs-button>
    </vs-row>
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <h4>
          {{ gateway.name }}
        </h4>
      </div>
      <vs-row vs-w="12">
        <vs-col
          class="mb-2"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="5"
          vs-sm="12"
          vs-xs="12"
        >
          <img
            src="../../../../assets/images/sensor/sensor.jpg"
            width="250"
            height="250"
          />
        </vs-col>
        <vs-col
          class="mb-2"
          vs-type="flex"
          vs-align="center"
          vs-lg="7"
          vs-sm="12"
          vs-xs="12"
        >
          <div style="width: 100%">
            <vs-row vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <h6 class="font-weight-bold">Gateway Name</h6>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <h6 class="ml-1">{{ gateway.name }}</h6>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <h6 class="font-weight-bold">Network</h6>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <h6 class="ml-1">{{ gateway.network }}</h6>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <h6 class="font-weight-bold">Serial ID</h6>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <h6 class="ml-1">{{ gateway.serial_id }}</h6>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <h6 class="font-weight-bold">Type</h6>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <h6 class="ml-1">{{ gateway.type }}</h6>
              </vs-col>
            </vs-row>
            <vs-row class="mt-3" vs-w="12">
              <vs-col
                class="textRight textResponsive"
                vs-lg="3"
                vs-sm="4"
                vs-xs="4"
              >
                <h6 class="font-weight-bold">Last Seen</h6>
              </vs-col>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <h6 class="ml-1">{{ lastseen }}</h6>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <h4>Sensor</h4>
      </div>
      <vs-table :data="sensorList">
        <template slot="thead">
          <!-- <vs-th style="padding: 0px">
            </vs-th> -->
          <vs-th
            v-for="item in header"
            :key="item"
            sort-key="name"
            style="padding: 0px"
          >
            {{ item }}
            <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td> 
            <vs-td :data="data[indextr].serial_id">
              {{ data[indextr].serial_id }}
            </vs-td>
            <vs-td :data="data[indextr].type">
              {{ data[indextr].type }}
            </vs-td>
            <vs-td :data="data[indextr].network">
              {{ data[indextr].network }}
            </vs-td>
            <vs-td :data="data[indextr].islocated">
              Unavailable
            </vs-td>
            <vs-td :data="data[indextr].active">
              <!-- {{ data[indextr].active }} -->
                <vs-icon icon="fiber_manual_record" v-if=" data[indextr].active == 1" color="primary" ></vs-icon>
                <vs-icon icon="fiber_manual_record" v-else-if=" data[indextr].active == 2" color="yellow" ></vs-icon>
                <vs-icon icon="fiber_manual_record" v-else color="grey"></vs-icon>
            </vs-td>
            <vs-td :data="data[indextr].signal">
              <!-- {{ data[indextr].signal }} -->
               <vs-icon icon="rss_feed" color="primary"></vs-icon>
            </vs-td>
            <vs-td :data="data[indextr].bat">
              <!-- {{ data[indextr].bat }} -->
               <vs-icon  icon="battery_full" color="primary"></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: "ViewGateway",
  props: ["gateway"],
  data: () => ({
    serial: "",
    security: "",
    name: "",
    type: "",
    sensorList: [],
    header: [
      "Name",
      "Serial Number",
      "Type",
      "Network",
      "Location",
      "Active Status",
      "Signal",
      "Battery",
    ],
    sensor: {
      id: null,
      name: null,
      serial: null,
      security: null,
      type: null,
      subtype: null,
    },
    lastseen: "",
  }),
  components: {},
  methods: {},
  created() {
    console.log(this.gateway.networkID);
    this.$http
      .get(this.$url + "sensor/" + this.gateway.networkID)
      .then((result) => {
        // this.sensorList = result.data;
        result.data.forEach((element) => {
          this.sensorList.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal:'100',bat:'100'});
        });
        console.log(result.data);
      });

    //   this.$http.get(this.$url+'gatewaysensor/'+this.gateway.networkID+'/'+this.$session.get('token')).then((result) => {
    //   this.sensorList = result.data
    //   console.log(result.data)
    // })
    this.$http
      .post(this.$url + "getlastseen", {
        gid: this.gateway.serial_id,
        type: this.gateway.type,
      })
      .then((result) => {
        // console.log(result.data)
        this.lastseen = this.$moment(result.data.lastSeenAt).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      });
  },
};
</script>
<style scoped>
.textRight {
  text-align: right;
}
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
</style>